import 'regenerator-runtime/runtime';
import 'bz-core-controls/utils/reflect-metadata';
import 'bz-core-controls/styles/colours.css';
import { setLegacyColourVariables } from 'bz-core-controls/styles/colours';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.tailwind.generated.css';
import './index.css';
import * as serviceWorker from './registerServiceWorker';
import './bootstrap/carousel.css';
import Moment from 'moment';

setLegacyColourVariables();

//import { library, dom } from '@fortawesome/fontawesome-svg-core';
//import { fas } from '@fortawesome/free-solid-svg-icons';

//library.add(fas);
//dom.watch();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element "#root" was not found.');
}

createRoot(rootElement).render(<App />);
serviceWorker.register();

/* eslint-disable no-extend-native */
Date.prototype.toJSON = function () {
  return Moment(this).format('YYYY-MM-DDTHH:mm:ss');
};
/* eslint-enable no-extend-native */
